import {definePlugin} from 'sanity'
import {hslaColor} from './schemas/hslaColor'
import {rgbaColor} from './schemas/rgbaColor'
import {color, ColorDefinition} from './schemas/color'
import {hsvaColor} from './schemas/hsvaColor'

export const colorInput = definePlugin({
  name: '@sanity/color-input',
  schema: {
    types: [hslaColor, hsvaColor, rgbaColor, color],
  },
})

export {hslaColor, rgbaColor, color, hsvaColor}
export {ColorInput} from './ColorInput'
export type {ColorDefinition}
export type {ColorValue, ColorInputProps, ColorOptions, ColorSchemaType} from './ColorInput'
